const unicodeRegexps = {
  cyrillicLetters: '\\p{Script=Cyrillic}',
  latinLetters: '\\p{Script=Latin}',
  dashes: '\\p{Dash_Punctuation}',
  numbers: '\\p{Number}',
  spaces: '\\p{Space_Separator}',
  ruAlpha: 'А-Яа-яЁё',
  enAlpha: 'A-Za-z',
};

const buildUnicodeRegexp = (include: (keyof typeof unicodeRegexps)[]) =>
  new RegExp(`^[${include.map(key => unicodeRegexps[key]).join('')}]*$`, 'u');

export const isValidCyrillicInitials = (value: string) =>
  buildUnicodeRegexp(['cyrillicLetters', 'dashes', 'spaces']).test(value);

export const isValidLatinInitials = (value: string) =>
  buildUnicodeRegexp(['latinLetters', 'dashes', 'spaces']).test(value);

export const isValidRuEnInitials = (value: string) =>
  buildUnicodeRegexp(['ruAlpha', 'enAlpha', 'dashes', 'spaces']).test(value);
